import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import {
	PanelBody,
	SelectControl,
	RangeControl,
	ToggleControl,
} from '@wordpress/components';
import { ColorPalette } from '@wordpress/block-editor';

const DEFAULT_SHADOW = {
	inset: false,
	x: '0px',
	y: '0px',
	blur: '10px',
	spread: '0px',
	color: 'rgba(0,0,0,0.3)',
};

const PREDEFINED_SHADOWS = {
	none: {},
	style1: {
		inset: false,
		x: '0px',
		y: '2px',
		blur: '5px',
		spread: '0px',
		color: 'rgba(0,0,0,0.1)',
	},
	style2: {
		inset: false,
		x: '0px',
		y: '5px',
		blur: '15px',
		spread: '0px',
		color: 'rgba(0,0,0,0.2)',
	},
	style3: {
		inset: false,
		x: '0px',
		y: '8px',
		blur: '25px',
		spread: '-5px',
		color: 'rgba(0,0,0,0.3)',
	},
};

const InspectorShadow = ( props ) => {
	const { label, value, onChange = () => {} } = props;

	const getShadowType = ( shadowValue ) => {
		if ( ! shadowValue || Object.keys( shadowValue ).length === 0 )
			return 'none';
		for ( const [ key, shadow ] of Object.entries( PREDEFINED_SHADOWS ) ) {
			if ( JSON.stringify( shadow ) === JSON.stringify( shadowValue ) ) {
				return key;
			}
		}
		return 'custom';
	};

	const [ shadowType, setShadowType ] = useState( () =>
		getShadowType( value )
	);

	const handleTypeChange = ( type ) => {
		setShadowType( type );
		if ( type !== 'custom' ) {
			onChange( PREDEFINED_SHADOWS[ type ] );
		}
	};

	const shadow = { ...DEFAULT_SHADOW, ...value };

	const setShadow = ( prop, val ) => {
		onChange( { ...shadow, [ prop ]: val } );
	};

	return (
		<>
			<SelectControl
				label="Shadow Style"
				value={ shadowType }
				options={ [
					{ label: 'None', value: 'none' },
					{ label: 'Style 1', value: 'style1' },
					{ label: 'Style 2', value: 'style2' },
					{ label: 'Style 3', value: 'style3' },
					{ label: 'Custom', value: 'custom' },
				] }
				onChange={ handleTypeChange }
			/>

			{ shadowType === 'custom' && (
				<>
					<ToggleControl
						label="Inset Shadow"
						checked={ shadow.inset }
						onChange={ ( val ) => setShadow( 'inset', val ) }
					/>
					<RangeControl
						label="X Offset"
						value={ parseInt( shadow.x ) }
						onChange={ ( val ) => setShadow( 'x', `${ val }px` ) }
						min={ -50 }
						max={ 50 }
					/>
					<RangeControl
						label="Y Offset"
						value={ parseInt( shadow.y ) }
						onChange={ ( val ) => setShadow( 'y', `${ val }px` ) }
						min={ -50 }
						max={ 50 }
					/>
					<RangeControl
						label="Blur Radius"
						value={ parseInt( shadow.blur ) }
						onChange={ ( val ) =>
							setShadow( 'blur', `${ val }px` )
						}
						min={ 0 }
						max={ 100 }
					/>
					<RangeControl
						label="Spread"
						value={ parseInt( shadow.spread ) }
						onChange={ ( val ) =>
							setShadow( 'spread', `${ val }px` )
						}
						min={ -50 }
						max={ 50 }
					/>
					<p>Shadow Color</p>
					<ColorPalette
						value={ shadow.color }
						onChange={ ( val ) => setShadow( 'color', val ) }
					/>
				</>
			) }
		</>
	);
};

export default InspectorShadow;
